"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SubMenu = require("./SubMenu.style");
var _SubMenuWithItems = _interopRequireDefault(require("./SubMenuWithItems/SubMenuWithItems"));
var _SubMenuWithMultiColumns = _interopRequireDefault(require("./SubMenuWithMultiColumns"));
var _Wrapper = _interopRequireDefault(require("./Wrapper"));
var _menuItems = require("../../../../constants/menuItems");
var _RequestTool = require("../../../RequestTool");
var _SubMenuWithIframe = require("../../../SubMenuWithIframe");
const SubMenu = props => {
  const {
    menuItems,
    showing,
    onNavItemSelected,
    onNavItemDeselected,
    positionToLeft,
    testId,
    walkMeId,
    customDropdown,
    parentNavItem,
    parentId,
    ModalComp,
    openChangePasswordModal
  } = props;
  const hideDropdown = (0, _react.useRef)(true);
  const [saleForceCode, setCode] = _react.default.useState(null);
  const [productInterest, setProductInterest] = _react.default.useState(undefined);
  const open = _ref => {
    let {
      code,
      metadata
    } = _ref;
    if (!code || !metadata) return;
    hideDropdown.current = false;
    setCode(code);
    setProductInterest(metadata.ProductInterestPredefinedValue);
  };
  const onDismiss = () => {
    hideDropdown.current = true;
    setCode(null);
  };
  const afterSubmit = () => {
    hideDropdown.current = true;
    setCode(null);
  };
  const onMouseLeave = () => {
    if (hideDropdown.current) {
      onNavItemDeselected();
    }
  };
  if ((!menuItems || menuItems.length === 0) && !customDropdown) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Wrapper.default, {
    showing: showing,
    positionToLeft: positionToLeft,
    testId: testId,
    parentNavItem: parentNavItem,
    onMouseEnter: onNavItemSelected,
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/_react.default.createElement(_SubMenu.SubMenuList, {
    id: testId,
    "data-walkmeid": walkMeId,
    hasMultiColumns: customDropdown === _menuItems.CUSTOM_DROPDOWN_MULTI_COLUMN
  }, customDropdown === _menuItems.CUSTOM_DROPDOWN_INTELLIGENCE_PAGES && /*#__PURE__*/_react.default.createElement(_SubMenuWithIframe.SubMenuWithIframeIntelligencePages, {
    showing: showing,
    width: 660,
    height: 400
  }), customDropdown === _menuItems.CUSTOM_DROPDOWN_MULTI_COLUMN && /*#__PURE__*/_react.default.createElement(_SubMenuWithMultiColumns.default, {
    menuItems: menuItems,
    onNavItemSelected: onNavItemSelected,
    onNavItemDeselected: onNavItemDeselected,
    testId: testId,
    walkMeId: walkMeId,
    showing: showing,
    positionToLeft: positionToLeft,
    parentId: parentId,
    openModal: open
  }), customDropdown === _menuItems.CUSTOM_DROPDOWN_COMMODITIES && /*#__PURE__*/_react.default.createElement(_SubMenuWithIframe.SubMenuWithIframeCommodities, {
    showing: showing,
    width: 396,
    height: 396
  }), customDropdown !== _menuItems.CUSTOM_DROPDOWN_INTELLIGENCE_PAGES && customDropdown !== _menuItems.CUSTOM_DROPDOWN_MULTI_COLUMN && customDropdown !== _menuItems.CUSTOM_DROPDOWN_COMMODITIES && Array.isArray(menuItems) && /*#__PURE__*/_react.default.createElement(_SubMenuWithItems.default, {
    menuItems: menuItems,
    onNavItemSelected: onNavItemSelected,
    onNavItemDeselected: onNavItemDeselected,
    testId: testId,
    walkMeId: walkMeId,
    showing: showing,
    positionToLeft: positionToLeft,
    openChangePasswordModal: openChangePasswordModal
  }))), saleForceCode && ModalComp && /*#__PURE__*/_react.default.createElement(_RequestTool.RequestToolModal, {
    saleForceCode: saleForceCode,
    productInterest: productInterest,
    onDismiss: onDismiss,
    afterSubmit: afterSubmit,
    ModalComp: ModalComp
  }));
};
var _default = exports.default = SubMenu;